import React, { useContext, useReducer, useRef } from "react";
import { useForm } from "react-hook-form";
import classNames from "lib/classNames";
import Field from "components/Form/Field";
import formReducer, { STATUS } from "reducers/formReducer";
import { DialogContext } from "contexts/DialogContext";
import { ACTIONS } from "reducers/dialogReducer";
import CalculatorResult from "components/CalculatorResult";

export default function CalculatorForm({
  id,
  fields,
  defaultValues: initialValues = null,
}) {
  const defaultValues = Object.keys(fields).reduce((acc, curr) => {
    acc[curr] = initialValues?.[curr] || null;
    return acc;
  }, {});
  const captchaRef = useRef(null);
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({ defaultValues });
  const [state, dispatch] = useReducer(formReducer, {
    status: STATUS.READY,
    message: null,
  });
  const { dispatch: dialogDispatch } = useContext(DialogContext);
  const submit = handleSubmit((data) => {
    if (state.status !== STATUS.READY) {
      return true;
    }
    dispatch({ type: ACTIONS.SUBMIT });
    dialogDispatch({
      type: ACTIONS.OPEN,
      payload: {
        title: "Recevoir les résultats",
        body: (
          <CalculatorResult
            values={{
              webform: id,
              ...data,
            }}
          />
        ),
      },
    });
    // TODO: defer this to when dialog is closed
    reset(defaultValues);
    return false;
  });

  return (
    <form id={id} className="flex flex-col gap-8" onSubmit={submit}>
      {Object.keys(fields).map((key, index) => {
        const field = fields[key];
        const fieldName = field["#webform_key"] || null;

        return (
          <Field
            key={fieldName || index}
            captchaRef={captchaRef}
            field={field}
            register={register}
            control={control}
            errors={errors}
          />
        );
      })}
      {(state.status === STATUS.SUCCESS || state.status === STATUS.ERROR) && (
        <div
          role="alert"
          className={classNames(
            "block font-semibold",
            state.status === STATUS.SUCCESS && "text-green-500",
            state.status === STATUS.ERROR && "text-red-500"
          )}
        >
          {state.message}
        </div>
      )}
    </form>
  );
}
